import Button from '@mui/material/Button'
import { Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { ConversionDialog } from '../conversionDialog'
import { RentabilityDialog } from '../rentabilityDialog'
import * as S from './styles.js'
import Slider from '@mui/material/Slider'
import { InvestmentSelect } from '../investmentSelect'
import { ResultDescription } from '../resultDescription'


const SignupSchema = Yup.object().shape({
	investment: Yup.string()
	.required('Preencha este campo.')
})

export function Result({ data, setData, setStepState, stepState }) {


	const [rentabilityOpen, setRentabilityOpen] = React.useState(false)

	const handleClickOpenDialog = () => {
		setRentabilityOpen(true)
	}

	const handleCloseDialog = () => {
		setRentabilityOpen(false)
	}

	const [ConversionDialogOpen, setConversionDialogOpen] = React.useState(false)

	const handleClickConversionDialogOpen = () => {
		setConversionDialogOpen(true)
	}

	const handleCloseConversionDialog = () => {
		setConversionDialogOpen(false)
	}

	return (<Formik
	initialValues={data}
	validationSchema={SignupSchema}
	>
		{({ values, errors, handleChange, handleSubmit, dirty, setFieldValue }) => (<>
			<S.Container>
				<S.Form>
					<S.Row>
						<S.Text style={{marginBottom: '15px'}}>Idade para a independência financeira:</S.Text>
						<S.UndelinedNumber style={{marginBottom: '15px'}}>{data.independenceAge}</S.UndelinedNumber>
					</S.Row>
					<Slider
					id={'independenceAge'}
					name={'independenceAge'}
					value={data.independenceAge}
					onChange={(e, newValue) => {
						setData({
							...data,
							independenceAge: newValue
						})
					}}
					aria-labelledby="input-slider"
					min={data.age + 1}
					max={100}
					style={{marginBottom: '15px'}}
					/>
					<S.Row>
						<S.Text style={{marginBottom: '15px'}}>Contribuição mensal:</S.Text>
						<S.UndelinedNumber style={{marginBottom: '15px'}}>R$ {data.monthlySave}</S.UndelinedNumber>
					</S.Row>
					<Slider
					value={data.monthlySave}
					onChange={(e, newValue) => {
						setData({
							...data,
							monthlySave: newValue
						})
					}}
					aria-labelledby="input-slider"
					min={0}
					step={100}
					max={50000}
					style={{marginBottom: '15px'}}
					/>
					<S.Row>
						<S.Text style={{marginBottom: '5px'}}>Renda durante a independência financeira:</S.Text>
						<S.UndelinedNumber style={{marginBottom: '15px'}}>R$ {data.desiredRetirement}</S.UndelinedNumber>
					</S.Row>
					<Slider
					value={data.desiredRetirement}
					onChange={(e, newValue) => {
						setData({
							...data,
							desiredRetirement: newValue
						})
					}}
					aria-labelledby="input-slider"
					min={0}
					step={100}
					max={50000}
					style={{marginBottom: '15px'}}
					/>
					<InvestmentSelect setData={setData} data={data} openDialog={handleClickOpenDialog}/>
				</S.Form>
				<ResultDescription data={data} variant="negative" handleClickConversionDialogOpen={handleClickConversionDialogOpen}/>
				<RentabilityDialog open={rentabilityOpen} handleCloseDialog={handleCloseDialog}/>
				<ConversionDialog data={data} open={ConversionDialogOpen} initialStep={2} handleCloseDialog={handleCloseConversionDialog}/>
			</S.Container>
			<S.Footer style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}>
				<S.Hr style={{
					width: '100%',
				}}/>
				<S.Container>
					<Button onClick={() => {
						setStepState({
							...stepState,
							index: 1
						})
					}} variant="contained" color="secondary">PASSO ANTERIOR</Button>
				</S.Container>
			</S.Footer>
		</>)}
	</Formik>)
}
